import React, { Component, useState } from 'react';
import { Alert } from 'react-bootstrap';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      input: {},
      errors: {},
      show: false
    };
    // const [show, setShow] = useState(true);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.headerDivs = [];
    this.contentDivs = [];
  }
  handleGoogleSubmit(e) {
    // this.setState({
    //   submitted: true
    // });
  }
  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;

    this.setState({
      input
    });
    this.validate();
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.validate()) {
      console.log(this.state);

      let input = {};
      input["entry.254249831"] = "";              //name
      input["entry.1797872018"] = "";            //email
      input["entry.957269946"] = "";            //message
      this.setState({ input: input });

      // alert('Demo Form is submited');
      this.setState({ show: true });
      setTimeout(() => {
        this.setState({ show: false });
      }, 10000);
      document.GoogleForm.submit();
      document.GoogleForm.reset();
    }
  }

  validate() {
    let input = this.state.input;
    let errors = {};
    let isValid = true;

    if (!input["entry.254249831"]) {
      isValid = false;
      errors["entry.254249831"] = "Please enter your name.";
    }

    if (!input["entry.1797872018"]) {
      isValid = false;
      errors["entry.1797872018"] = "Please enter your email Address.";
    }

    if (typeof input["entry.1797872018"] !== "undefined") {

      var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      if (!pattern.test(input["entry.1797872018"])) {
        isValid = false;
        errors["entry.1797872018"] = "Please enter valid email address.";
      }
    }

    if (!input["entry.957269946"]) {
      isValid = false;
      errors["entry.957269946"] = "Please enter your comment.";
    }

    this.setState({
      errors: errors
    });

    return isValid;
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="view-page-container contact-page">
        <h2 className="text-center main-header" ref={div => (this.headerDivs[1] = div)}>Ping me here!</h2>
        <form className="d-none" name="gform" id="gform" encType="text/plain" action="https://docs.google.com/forms/d/e/1FAIpQLSdbCrDfEgOSDDhBGqOxpZ546eeAQZJolcQqMdKVbNg2gDau-g/formResponse?" target="hidden_iframe"
          onSubmit={this.handleGoogleSubmit}>
          First name:<br />
          <input type="text" name="entry.254249831" id="entry.254249831" /><br />
          Last name:<br />
          <input type="text" name="entry.1797872018" id="entry.1797872018" />
          <input type="submit" value="Submit" />
        </form>
        <div className="container">
          <div className="row justify-content-center mb-4">
            <div className="col-md-6">
              {(() => {
                if (this.state.show) {
                  return (
                    <Alert variant="danger" onClose={() => this.setState({ show: false })} dismissible>
                      <Alert.Heading>Thanks for contacting Me!</Alert.Heading>
                      <p>
                        I will try my best to revert you as soon as possible.
                      </p>
                    </Alert>
                  );
                }
              })()}
              <form id="GoogleForm" name="GoogleForm" encType="text/plain" action="https://docs.google.com/forms/d/e/1FAIpQLSdbCrDfEgOSDDhBGqOxpZ546eeAQZJolcQqMdKVbNg2gDau-g/formResponse?" target="hidden_iframe">
                <div className="form-group">
                  <label htmlFor="entry.254249831">Name:</label>
                  <input
                    type="text"
                    name="entry.254249831"
                    value={this.state.input.name}
                    onChange={this.handleChange}
                    className="form-control"
                    placeholder="Enter Name"
                    id="entry.254249831" />
                  <div className="text-danger">{this.state.errors['entry.254249831']}</div>
                </div>
                <div className="form-group">
                  <label htmlFor="entry.1797872018">Email Address:</label>
                  <input
                    type="text"
                    name="entry.1797872018"
                    value={this.state.input.email}
                    onChange={this.handleChange}
                    className="form-control"
                    placeholder="Enter Email"
                    id="entry.1797872018" />
                  <div className="text-danger">{this.state.errors['entry.1797872018']}</div>
                </div>
                <div className="form-group">
                  <label htmlFor="entry.957269946">Comment:</label>
                  <textarea
                    name="entry.957269946"
                    value={this.state.input.comment}
                    onChange={this.handleChange}
                    placeholder="Enter Comment"
                    className="form-control" />
                  <div className="text-danger">{this.state.errors['entry.957269946']}</div>
                </div>
                <div className="text-center">
                  <input type="button" value="Submit" className="btn btn-success" onClick={this.handleSubmit} />
                </div>
              </form>
            </div>
          </div>

        </div>

        <iframe name="hidden_iframe" id="hidden_iframe" style={{ display: 'none' }} ></iframe>
      </div>
    );
  }
}
export default Contact;
